import { useEffect, useState } from 'react'

const useNotification = () => {
    const [addNotification, setAddNotification] = useState(null)

    useEffect(() => {
    // Check if addNotification is available on the window object
        if (window.addNotification) {
            setAddNotification(() => window.addNotification)
        } else {
            const interval = setInterval(() => {
                if (window.addNotification) {
                    setAddNotification(() => window.addNotification)
                    clearInterval(interval)
                }
            }, 100) // Check every 100ms

            return () => clearInterval(interval) // Cleanup on unmount
        }
    }, [])

    return addNotification
}

export default useNotification
